<template>
  <div class="pull-refresh">
    <div class="pull-refresh__loader" :style="{
      top: loaderTop + 'px',
      opacity: loaderTop * 2 / 100
    }">
      <div
        class="pull-refresh__circle"
        :class="{
          'pull-refresh__circle--animation': (loaderTop > 75)
        }"
        :style="{
          transform: 'rotate(' + (loaderTop + 100) + 'deg)'
        }"
      />
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      pMoveY: 0,
      pMoveX: 0,
      pStart : { x: 0, y: 0 },
      pStop  : { x: 0, y: 0 },
    };
  },
  computed: {
    loaderTop() {
      return Math.min(
        ((this.pMoveY - this.pStart.y) / 3), 100
      );
    }
  },
  methods: {
    swipeStart(e) {
      if (typeof e['targetTouches'] !== "undefined"){
        var touch = e.targetTouches[0];
        this.pStart.x = touch.screenX;
        this.pStart.y = touch.screenY;
      } else {
        this.pStart.x = e.screenX;
        this.pStart.y = e.screenY;
      }
    },
    swipeMove(e) {
      if (typeof e['targetTouches'] !== "undefined"){
        var touch = e.targetTouches[0];
        this.pMoveX = touch.screenX;
        this.pMoveY = touch.screenY;
      } else {
        this.pMoveX = e.screenX;
        this.pMoveY = e.screenY;
      }
    },
    swipeEnd(e) {
      if (typeof e['changedTouches'] !== "undefined"){
        var touch = e.changedTouches[0];
        this.pStop.x = touch.screenX;
        this.pStop.y = touch.screenY;
      } else {
        this.pStop.x = e.screenX;
        this.pStop.y = e.screenY;
      }

      this.pMoveX = 0;
      this.pMoveY = 0;

      this.swipeCheck();

      this.pStart.x = 0;
      this.pStart.y = 0;
    },
    swipeCheck(){
      var changeY = this.pStart.y - this.pStop.y;
      var changeX = this.pStart.x - this.pStop.x;

      if (this.isPullDown(changeY, changeX)) {
        window.location.reload();
      }
    },
    isPullDown(dY, dX) {
      return dY < 0 && (
        (Math.abs(dX) <= 100 && Math.abs(dY) >= 220)
        || (Math.abs(dX) / Math.abs(dY) <= 0.3 && dY >= 60)
      );
    }
  },
  mounted() {
    if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
      return;
    }

    document.addEventListener('touchmove', this.swipeMove, false);
    document.addEventListener('touchstart', this.swipeStart, false);
    document.addEventListener('touchend', this.swipeEnd, false);
  },
  destroyed() {
    if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
      return;
    }

    document.removeEventListener('touchmove', this.swipeMove, false);
    document.removeEventListener('touchstart', this.swipeStart, false);
    document.removeEventListener('touchend', this.swipeEnd, false);
  }
}
</script>

<style lang="scss" scoped>
.pull-refresh {
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  top: -40px;
  width: 100%;
  z-index: 90;

  &__loader {
    align-items: center;
    background: #ffffff;
    border-radius: 9999px;
    box-shadow: 0px 0px 5px #0000000F;
    display: flex;
    height: 40px;
    justify-content: center;
    position: relative;
    top: 0;
    width: 40px;
  }

  &__circle {
    border: 4px solid $color-primary;
    border-radius: 9999px;
    border-top: 4px solid transparent;
    height: 25px;
    width: 25px;
  }

  &__circle--animation {
    animation-name: spin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
